import type { RouteRecordRaw } from "vue-router"
import auth from "@/middlewares/auth"
import config from "@/middlewares/config"
import { useAccountStore } from "@/stores/account"
import { waitForEstablishments } from "@/router/waitForEstablishments"

const canAccessAssistant = () => {
  const accountStore = useAccountStore()
  return !!accountStore.hasPremium
}

const assistantRoutes: RouteRecordRaw[] = [
  {
    path: "/assistant",
    name: "assistant",
    component: () => import("@/views/assistant/AssistantView.vue"),
    beforeEnter: async (to) => {
      const establishmentId = to.query.establishment
      const conversationId = to.query.conversation
      if (establishmentId) {
        sessionStorage.setItem("requestedEstablishmentId", String(establishmentId))
      }
      if (conversationId) {
        sessionStorage.setItem("assistantReturnConversationId", String(conversationId))
      }
      if (establishmentId || conversationId) {
        sessionStorage.setItem("pendingAssistantDeepLink", "1")
      }

      await waitForEstablishments()

      if (!canAccessAssistant()) {
        return { name: "home" }
      }
    },
    meta: {
      middleware: [auth, config],
      title: "assistant.page_title",
      requiresConfig: true,
    },
  },
]

export default assistantRoutes
